module.exports = __webpack_public_path__ + "static/img/icon3_2.0c56f20.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon3_2.png
// module id = Ew9f
// module chunks = 120